import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogContent,
    MenuItem,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import AppDialogTitle from '../../../ui/appDialogTitle';
import { isLocalDev } from '../../../../utils/environment';
import { LensConfigurationService } from '../../../../service/validDataService';
import validLookup from '../../../../utils/validLookup';

export const initialValuesLensTreatmentForm = {
    name: '',
    category: 'coating',
    cost: 0,
    retailPrice: 0,
    isStackable: true,
    status: validLookup.validStatus.active,
    notes: '',
};

const treatmentCategories = [
    { value: 'coating', label: 'Coating' },
    { value: 'tint', label: 'Tint' },
    { value: 'photochromic', label: 'Photochromic' },
    { value: 'polarization', label: 'Polarization' },
    { value: 'uv-protection', label: 'UV Protection' },
    { value: 'other', label: 'Other' },
];

export default function ValidLensTreatmentInputForm({ open, onClose, onRecordAdded }) {

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            const response = await LensConfigurationService.addTreatment(values)
            const { code, data, message } = response

            setSubmitting(false)

            if (code === 0) {
                toast.success(message);
                resetForm();
                onRecordAdded(data)
                onClose();
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.error(error);
            }
            setSubmitting(false)
            toast.error('Failed to add lens treatment');
        }
    };

    return (
        <Dialog open={open} maxWidth={'sm'} fullWidth>
            <AppDialogTitle title={"Add Lens Treatment"} onClose={onClose} />
            <DialogContent sx={{ mt: 1, mb: 1 }}>
                <Formik
                    initialValues={initialValuesLensTreatmentForm}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <Grid container spacing={2}  sx={{mt: 1}}>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="name"
                                        label="Treatment Name"
                                        required
                                        fullWidth
                                        size="small"
                                    />
                                    <ErrorMessage name="name">{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name="category"
                                        label="Category"
                                        required
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        {treatmentCategories.map((cat) => (
                                            <MenuItem key={cat.value} value={cat.value}>
                                                {cat.label}
                                            </MenuItem>
                                        ))}
                                    </Field>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name='status'
                                        label="Status"
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        <MenuItem value={"active"}>Active</MenuItem>
                                        <MenuItem value={"inactive"}>Inactive</MenuItem>
                                    </Field>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name="cost"
                                        label="Cost"
                                        type="number"
                                        fullWidth
                                        size="small"
                                        inputProps={{ step: "0.01" }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Field
                                        as={TextField}
                                        name="retailPrice"
                                        label="Retail Price"
                                        type="number"
                                        fullWidth
                                        size="small"
                                        inputProps={{ step: "0.01" }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={values.isStackable}
                                                onChange={(e) => setFieldValue('isStackable', e.target.checked)}
                                                name="isStackable"
                                            />
                                        }
                                        label="Stackable (can be combined with other treatments)"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="notes"
                                        label="Notes"
                                        multiline
                                        rows={2}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmitting}
                                    >
                                        Create
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};
